import { render, staticRenderFns } from "./PaymentAlertBanner.vue?vue&type=template&id=4eb25885"
import script from "./PaymentAlertBanner.vue?vue&type=script&lang=js"
export * from "./PaymentAlertBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports